<template>
    <h2>{{$t('patientHistory')}}</h2>
  </template>
  
  <script>
  export default {
      name: 'ortho-history'
  }
  </script>
  
  <style>
  
  </style>
  